import {
  forwardRef,
  useCallback,
  useContext,
  useEffect,
  useImperativeHandle,
  useState,
} from "react";
import { FarmContext } from "../../AppContent";
import { getLandsSum } from "../../repos/LandRepo";
import { ILandsSum } from "../../types/ILand";
import { Land } from "../../Components/Sections/Land/Land";
import { LandsRecapitulationTable } from "../../Components/Recapitulation/LandsRecapitulationTable";
import { IFieldLand } from "../../types/IFieldBook";
import { useTranslation } from "react-i18next";

interface Props {
  fieldLands: IFieldLand[];
  refreshFieldBooks: () => void;
}

export interface ChildRef {
  refreshLandsSum: () => void;
}

export const FieldLandSection = forwardRef<ChildRef, Props>(
  ({ fieldLands, refreshFieldBooks }, ref) => {
    const [landsSum, setLandsSum] = useState<ILandsSum>();
    const [isSumLoading, setIsSumLoading] = useState(false);

    const farmUuid = useContext(FarmContext).farm?.uuid;

    const handleGetLandsSum = useCallback(() => {
      if (farmUuid && !!fieldLands?.length) {
        setIsSumLoading(true);
        getLandsSum(
          farmUuid,
          fieldLands.map((item) => item.land.uuid)
        )
          .then((e) => setLandsSum(e.sum))
          .catch(() => {})
          .finally(() => setIsSumLoading(false));
      }
    }, [farmUuid, fieldLands]);

    useEffect(handleGetLandsSum, [handleGetLandsSum]);

    useImperativeHandle(ref, () => ({
      refreshLandsSum: handleGetLandsSum,
    }));

    const { t } = useTranslation();

    return (
      <div className="form-container">
        {!!landsSum && !isSumLoading && (
          <LandsRecapitulationTable landsSum={landsSum} />
        )}
        <h3>{t("FieldPlots")}</h3>
        {farmUuid &&
          fieldLands.map((fl) => (
            <Land
              key={fl.uuid}
              land={fl.land}
              reloadLands={() => {}}
              reloadLandsSum={refreshFieldBooks}
              disableEdit
              fieldLandUuid={fl.uuid}
            />
          ))}
      </div>
    );
  }
);
